import type { BaseNavItem } from '@cks-internal/react-base/dist/BaseComponents/Nav/types';

const compareNavItems = (left: BaseNavItem, right: BaseNavItem) => {
  return (left.text ?? '').localeCompare(right.text ?? '', undefined, { sensitivity: 'base' });
};

const sortNavItem = (item: BaseNavItem): BaseNavItem => {
  if (!('subItems' in item) || !item.subItems?.length) {
    return item;
  }

  const sortedSubItems = item.subItems
    .map(sortNavItem)
    .map((subItem, index) => ({ subItem, index }))
    .sort((left, right) => {
      const comparison = compareNavItems(left.subItem, right.subItem);
      return comparison !== 0 ? comparison : left.index - right.index;
    })
    .map(({ subItem }) => subItem);

  return {
    ...item,
    subItems: sortedSubItems
  };
};

export const sortNavSubitemsAlphabetically = (items: BaseNavItem[]) => {
  return items.map(sortNavItem);
};
